<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{
      title: '服务管理',
      search,
      api,
      afterGetDetail,
      beforeSave,
      ...table,
      ...dialog,
    }"
  >
  </zh-table-page>

</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox } from "element-plus";
import moment from "moment"
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const state = reactive({
      search: [
        {
          label: "事件key",
          placeholder: "事件key",
          value: "eventKey",
        },
      ],
      api: {
        list: "postConfigPage",
        delete: "deleteConfigDelete",
        add: "postConfigSave",
        edit: "postConfigUpdate",
        detail: "getConfig",
        tree: "",
      },
      table: {
        columns: [
          { label: "事件key", prop: "eventKey" },
          { label: "重试次数", prop: "maxRetry" },
          { label: "消息类型", prop: "messageType", 
          scopeFun: (scope) => {
            if (scope.row.messageType) {
              return scope.row.messageType.desc;
            }
            return '--'

          },
          },
          { label: "写入重试时间", prop: "writeRetryTime" },
          { label: "等待重试时间", prop: "writeTimeOut" },
        ],
        operations: [
          { label: "编辑" },
          { label: "删除", type: "danger" },
        ],
        rowKey: "id",
      },
      dialog: {
        dialogForm: [
          {
            label: "事件key",
            placeholder: "请输入事件key",
            value: "eventKey",
          },
          {
            component:'zh-input-number',
            label: "最大重试次数",
            placeholder: "请输入消息最大重试次数",
            value: "maxRetry",
            defaultValue:1,
            min:1,
            step:1,
            max:5            

          },
          {
            component: "zh-select",
            label: "消息类型",
            placeholder: "请选择消息类型",
            value: "messageType",
            defaultValue:1,
            options:[
              {value:1,label:'告警消息'},
              {value:2,label:'普通消息'},
            ],
          },
          {
            component: "zh-select",
            label: "所属服务",
            placeholder: "请选择所属服务",
            value: "serviceId",
            url:"postServiceList",
            field: {
              id: "value",
              serviceName: "label",
            },
          },
          {
            component: "zh-select",
            label: "配置类型",
            placeholder: "请选择配置类型",
            value: "configType",
            defaultValue:4,
            options:[
              {value:4,label:'websocket'},
              {value:5,label:'企业微信'},
            ],
          },
          {
            component:'zh-input-number',
            label: "报警级别",
            placeholder: "请输入报警级别",
            value: "alarmLevel",
            defaultValue:1,
            min:1,
            step:1,
            showCondition:(item)=>{
              return item.messageType === 1
            }
          },
          {
            label: "clientId",
            placeholder: "请输入clientId",
            value: "clientId",
            showCondition:(item)=>{
              return item.configType === 4
            }
          },
          {
            label: "url",
            placeholder: "请输入url",
            value: "url",
            showCondition:(item)=>{
              return item.configType === 5
            }
          },
        ],
        dialogRules: {
          eventKey: [
            { required: true, message: "事件key不能为空", trigger: "blur" },
          ],
          alarmLevel: [
            { required: true, message: "报警级别不能为空", trigger: "blur" },
          ],
          clientId: [
            { required: true, message: "clientId不能为空", trigger: "blur" },
          ],
          url: [
            { required: true, message: "url不能为空", trigger: "blur" },
          ],
          serviceId: [
            { required: true, message: "请选择所属服务", trigger: "blur" },
          ],
          configType: [
            { required: true, message: "请选择配置类型", trigger: "blur" },
          ],
          
        
         
        },
      },
    });
    onMounted(() => {
    });
    //点击编辑处理详情数据
    const afterGetDetail = (data) => {
      return {
        ...data,
        messageType: data.messageType?.value ?? 1,
        alarmLevel: data.message?.alarmLevel ?? null,
        clientId: data.message.config?( data.message.config?.clientId??null):null,
        configType: data.message.config?( data.message.config.configType?Number(data.message.config.configType):null):null,
        url: data.message.config?( data.message.config?.url??null):null,
      };
    };
    //新增编辑保存之前
    const beforeSave = (form)=>{
      return {
        ...form,
        message:{
          messageType:form.messageType,
          messageTypeEnum:form.messageType,
          config:{
            configType:form.configType,
            url:form.configType===5?(form.url?form.url:null):null,//微信时才传值
            clientId:form.configType===4?(form.clientId?form.clientId:null):null,//websocket时才传值
          },
          alarmLevel:form.messageType === 1?(form.alarmLevel?form.alarmLevel:null):null,//告警消息时才传值
        }
      }
    }

    return {
      ...toRefs(state),
      tableRef,
      afterGetDetail,
      beforeSave,
    };
  },
});
</script>
